import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="A welcoming view of Macs Diner, showcasing a cozy dining atmosphere" 
          className="hero-image" 
        />
        <p className="eyebrow">Macs Diner</p>
        <h1>Discover Your New Favorite Diner!</h1>
        <p className="lede">
          Savor mouthwatering dishes in a friendly atmosphere at Macs Diner.
        </p>
      </header>

      <section className="cards">
        <article>
          <h2>Welcome to Macs Diner</h2>
          <p>
            At Macs Diner, we serve up delicious meals made from locally sourced ingredients. Explore our menu, read customer reviews, and find out about our special events that make dining with us a memorable experience.
          </p>
          <a href="/menu" className="cta-button">View Our Menu</a>
        </article>
      </section>
    </div>
  );
}

export default App;